import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import logo from "../asset/logo/LOGO_ORANGE.svg";
import { COOKIE_CHOICE_EVENT, getAnalyticsConfig, getCookieChoice, setCookieChoice } from "./cookieChoice";

// The cookie popup - the same look as in the customer portal (white card, logo, two equal buttons). Shown on the
// first visit, and only when statistics are switched on; otherwise only strictly necessary storage is used.
export const CookieConsent = () => {
  const [t] = useTranslation("global");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => {
      const choice = getCookieChoice();
      // Not while the participant is being asked about their data - one question at a time
      const onConsentScreen = window.location.pathname.startsWith("/breefInvite");
      getAnalyticsConfig().then((config) => setVisible(!choice && !onConsentScreen && config?.provider === "umami"));
    };
    update();
    window.addEventListener(COOKIE_CHOICE_EVENT, update);
    return () => window.removeEventListener(COOKIE_CHOICE_EVENT, update);
  }, []);

  if (!visible) return null;
  const button = { flex: 1, color: "#FFFFFF", padding: "1rem 1.2rem", borderRadius: "1rem", border: 0, fontWeight: 600, fontSize: "0.9rem", cursor: "pointer" };
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.6)", fontFamily: "Roboto, Arial, sans-serif", overflowY: "auto", padding: "1rem 0" }}>
      {/* The card scrolls inside the screen, so the buttons stay reachable on a small phone */}
      <div role="dialog" aria-labelledby="cookie-title" style={{ position: "relative", background: "#FFFFFF", borderRadius: "1.5rem", boxShadow: "0 25px 50px rgba(0,0,0,0.25)", maxWidth: "32rem", maxHeight: "100%", overflowY: "auto", margin: "0 1rem", padding: "2rem" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.5rem" }}>
          <img src={logo} alt="Breefer" height={50} />
        </div>
        <h2 id="cookie-title" style={{ fontSize: "1.4rem", fontWeight: 700, textAlign: "center", color: "#1f2937", margin: "0 0 1rem" }}>
          {t("cookieConsent.title")}
        </h2>
        <p style={{ color: "#4b5563", textAlign: "center", lineHeight: 1.6, margin: "0 0 2rem" }}>{t("cookieConsent.body")}</p>
        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
          <button style={{ ...button, background: "#6b7280" }} onClick={() => setCookieChoice("declined")}>
            {t("cookieConsent.declineButton")}
          </button>
          <button style={{ ...button, background: "#EB6608" }} onClick={() => setCookieChoice("accepted")}>
            {t("cookieConsent.acceptButton")}
          </button>
        </div>
        <p style={{ marginTop: "1.5rem", textAlign: "center", fontSize: "0.75rem", color: "#9ca3af" }}>
          {t("cookieConsent.footer")}{" "}
          <a href="/privacy#cookies" style={{ color: "#9ca3af" }}>
            {t("cookieConsent.readMore")}
          </a>
        </p>
      </div>
    </div>
  );
};
